import { Badge } from '@components/badge';
import { Card } from '@components/card';
import { IconEmail } from '@components/icons/email';
import { Stack } from '@components/stack';
import { Text } from '@components/text';
import { useScopedTranslate } from '@locale/translate';

export const SystemEmailCard = () => {
  const { t } = useScopedTranslate(locale);
  return (
    <Card space={3} variant="white">
      <Stack orientation="horizontal" justify="space-between" align="center">
        <Stack space={3} orientation="horizontal" align="center">
          <IconEmail color="elementPurple80" />
          <div>
            <Text text="50skills" font="semibold14" />
            <Text text="noreply@mg.50skills.app" font="regular14" color="textSecondary" />
          </div>
        </Stack>
        <Stack orientation="horizontal" space={2} align="center">
          <Badge size="md" variant="indigo" text={t('default')} />
        </Stack>
      </Stack>
    </Card>
  );
};

const locale = {
  en: {
    default: 'Default',
    disabled: 'Disabled',
  },
};
